import { IconButton, Tooltip } from '@mui/material';
import FavoriteButton from '@src/main/ui/components/common/Dashboard/common/buttons/FavoriteButton/FavoriteButton';
import Icon from '@src/main/ui/components/common/Icon/Icon';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import styles from './DashboardCardShowMoreButtons.module.scss';

interface DashboardCardShowMoreButtonsProps {
  onClickFavorites: () => void;
  launchUrl: string;
  isFavorite: boolean;
}

const DashboardCardShowMoreButtons: FC<DashboardCardShowMoreButtonsProps> = ({
  onClickFavorites,
  launchUrl,
  isFavorite,
}) => (
  <div className={styles.dashboardCardShowMoreButtons}>
    <FavoriteButton onClickFavorites={onClickFavorites} isFavorite={isFavorite} fontSize="28px" />
    <Tooltip title="Launch">
      <Link to={launchUrl}>
        <IconButton size="small" aria-label="Launch">
          <span style={{ fontSize: '25px' }}>
            <Icon iconId="launch" />
          </span>
        </IconButton>
      </Link>
    </Tooltip>
  </div>
);

export default DashboardCardShowMoreButtons;
